var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { componentTypes } from "../Form/form-constants";
export var setParticipantProps = function (participantField, optionals, options) {
    if (optionals === void 0) { optionals = {}; }
    var fields = participantField.fields, otherProps = __rest(participantField, ["fields"]);
    var showAsAccordion = +options.no_accordion !== 1;
    var connectedAccordion = showAsAccordion && +options.accordion_all_open !== 1;
    var fieldset = {
        title: showAsAccordion ? otherProps.title : null,
        component: showAsAccordion ? componentTypes.ACCORDION : componentTypes.FIELD_SET,
        connectedAccordion: connectedAccordion,
        fields: fields.map(function (field) { return (__assign(__assign({}, field), { className: options.fieldClassName, component: showAsAccordion ? componentTypes.ACCORDION_ITEM : componentTypes.FIELD_SET })); })
    };
    if (!showAsAccordion)
        return __assign(__assign(__assign({}, otherProps), optionals), fieldset);
    return __assign(__assign(__assign({}, otherProps), optionals), { fields: [fieldset] });
};
